/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestJoin.defs'
export { main as default } from './requestJoin.defs'
